// removed by extract-text-webpack-plugin
module.exports = {"Haricot":"#01A92B","ScreenSMMin":"(min-width: 768px)","container":"G9f9cf0 G3c3c24","tick":"Ga5d8cc","text":"G5c5774","highlighted":"G3693f8"};